import fr from 'facet-rest';
import React from 'react';
import Typography from 'Components/UI/Typography';
import {
  FDIcon,
  FDStack,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import {
  RecurringExpenseItemOverride,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingRecurringExpenses/metaOverrideSet';
import { useSurveyContext } from 'Views/Onboarding/Pages/Survey/SurveyContext';
import MiscItem from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingSelectRecurringExpenses/MiscItem';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { displayErrorMessageWithChecks } from 'Context/SnackbarContext/utils';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { dataAttrs } from 'Helpers/Testing';


function MiscItemSection({ resources }) {
  const { onboardingStepResource, setOnboardingStepCollection } = useSurveyContext();
  const { displayErrorMessage } = useSnackbarContext();

  if (resources.length === 0) {
    return null;
  }

  const onDelete = async (item) => {
    try {
      await item.delete();
      const preRefreshOptions = onboardingStepResource.attr('options');
      const onboardingStepCollection = await onboardingStepResource.link('self').get();
      onboardingStepCollection.resources().head().attr('options', preRefreshOptions); // we need to preserve options pre refresh so that we don't lose them
      setOnboardingStepCollection(onboardingStepCollection);
    } catch (err) {
      displayErrorMessageWithChecks(err, displayErrorMessage, 'Failed to delete custom expense');
    }
  };

  const onChange = async (item) => {
    try {
      await item.submit();
    } catch (err) {
      displayErrorMessageWithChecks(err, displayErrorMessage, 'Failed to update custom expense');
    }
  };

  return (
    <FDStack direction={'column'} spacing={2} {...dataAttrs('onboarding-custom-expense-section')}>
      <FDStack direction={'row'} justifyContent={'space-between'} padding={2}>
        <Typography variant="h4" weight="extraBold" color={'primary'}>
          {'Custom expenses'}
        </Typography>
        <FDIcon icon={'fingerprint'} color={'secondary'} />
      </FDStack>
      <FDStack direction={'column'} spacing={1}>
        {resources.map((item) => {
          return (<MetaResourceRenderer
            resource={item}
            layout={MiscItem}
            metaOverrideSet={RecurringExpenseItemOverride}
            LayoutProps={{
              onDelete,
              onBlur: onChange,
            }}
          />);
        })}
      </FDStack>
    </FDStack>
  );
}

MiscItemSection.propTypes = {
  resources: PropTypes.arrayOf(fr.Resource).isRequired,
};

MiscItemSection.defaultProps = {
};

export default MiscItemSection;
